import { Component } from 'react'
import { connect } from "react-redux"


// INCOMPLETO: para q las alarmas sean utiles, deberian sonar aunque la app este en el background, 
// y segun https://blog.prototyp.digital/what-we-learned-about-pwas-and-audio-playback/ en ios no se puede


class AlertSystem extends Component {
    constructor(props){
        super(props)
        this.state = {
            alerts: {}
        }
    }

    componentDidMount() {
        if(this.props.visits){

        }
        // this.continueChecking = true
        // const temp = localStorage.getItem('sync_queue')

        // if (!temp) {
        //     localStorage.setItem('sync_queue', JSON.stringify({
        //         lastUpdate: Date.now(),
        //         queue: []
        //     }))
        // }

        // this.doSync()
    }

    shouldComponentUpdate() {
    }

    componentWillUnmount() {
        // this.continueChecking = false
    }

    render() {
        return null
    }
}

const mapStateToProps = (state) => {
    return {
        visits: state.app.global.visits,
    }
};

export default connect(mapStateToProps, null)(AlertSystem);